import { getCurrentConversation } from 'conversations/modules/conversation/selectors'
import { BansState } from 'conversations/modules/endUser/reducer'
import { captureError } from 'conversations/utils/logRocket'
import { createSelector } from 'reselect'
import { EndUser } from 'shared/typings/endUser/EndUser'
import { Location } from 'shared/typings/enrichment/Location'

import { RootState } from 'typesafe-actions'

type EndUsersById = Record<string, EndUser | undefined>

type NewEndUserPresenceById = Record<string, number>

const root = (state: RootState) => state.convo.endUser

export const getLocation = (endUser?: EndUser): Location | undefined => {
  try {
    const lastContextLocation: Location = JSON.parse(
      endUser?.attributes?.last_context_location ?? '{}'
    )
    const socialLocation = endUser?.socialProfile?.geo

    const geo = socialLocation || lastContextLocation

    if (!geo || !geo.city) {
      return undefined
    }

    return geo
  } catch (error) {
    captureError(error, 'Get location failed')
    return undefined
  }
}

export const getEndUser = (endUserId?: string) =>
  createSelector(root, (endUser) => (!endUserId ? undefined : endUser.byId[endUserId]))

export const getEndUserPresence = (endUserId?: string) => (state: RootState) =>
  !endUserId ? false : presencesById(state)[endUserId] !== undefined

export const getEndUserPageTitle =
  (endUserId?: string) =>
  (state: RootState): string | undefined =>
    getEndUserPage(endUserId)(state)?.title

export const getEndUserPage = (endUserId?: string) => (state: RootState) =>
  !endUserId ? undefined : getEndUserPages(state)[endUserId]

export const getEndUserPages = (state: RootState) => root(state).pageById

export const byId = (state: RootState): EndUsersById => root(state).byId

export const presencesById = (state: RootState): NewEndUserPresenceById => root(state).presenceById

export const getBans = (state: RootState): BansState => root(state).bans

export const getIsBanned = () =>
  createSelector(getBans, getCurrentConversation, (bans, conversation) => {
    if (!conversation) {
      return false
    }
    const ipAddress = conversation.context?.ip
    const id = conversation.endUserId

    return (ipAddress && bans.ips.includes(ipAddress)) || bans.endUserIds.includes(id)
  })
